import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAnalytics } from '../hooks/useAnalytics';
export function CTASection() {
  const {
    trackClick
  } = useAnalytics();
  return <section className="py-12 sm:py-16 md:py-20 bg-charcoal relative overflow-hidden text-center" data-id="element-514">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] sm:w-[600px] h-[400px] sm:h-[600px] bg-ginger opacity-10 rounded-full blur-[100px] pointer-events-none" data-id="element-515" />

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-516">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} data-id="element-517">
          <h2 className="text-ginger/60 font-light tracking-[0.2em] uppercase mb-3 sm:mb-4 text-xs" data-id="element-518">
            Why GINEXT Feels Different
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-bone mb-6 sm:mb-8 leading-relaxed px-4 font-light" data-id="element-519">
            Because it is. Most products try to silence sensation.{' '}
            <br className="hidden sm:block" data-id="element-520" />
            <span className="text-white font-normal" data-id="element-521">
              GINEXT supports circulation so pressure can release naturally.
            </span>
          </p>

          <div className="w-full h-px bg-white/10 mb-6 sm:mb-8" data-id="element-522" />

          <p className="text-sm sm:text-base text-gray-400 mb-2 sm:mb-3 font-light" data-id="element-523">
            That's the difference between masking heaviness and helping your
            legs feel lighter again.
          </p>

          <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-white mb-3 sm:mb-4 leading-tight tracking-tight" data-id="element-524">
            Feel the Warmth. <br data-id="element-525" />
            <span className="text-ginger" data-id="element-526">Release the Pressure.</span>
          </h2>

          <p className="text-sm sm:text-base text-gray-400 mb-6 sm:mb-8 font-light" data-id="element-527">
            Move through your day lighter.
          </p>

          <a href="#bundles" className="inline-block w-full sm:w-auto scroll-smooth" onClick={() => trackClick({
          location: 'cta_section',
          destination: '#bundles'
        })} data-id="element-528">
            
          </a>

          {/* Trust Stats - Below CTA */}
          <div className="mt-4 sm:mt-5 flex flex-col items-center gap-1" data-id="element-529">
            <div className="flex items-center gap-[2px]" aria-label="4.8 out of 5 stars" data-id="element-530">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 sm:w-5 sm:h-5 fill-ginger text-ginger" data-id="element-531" />)}
            </div>
            <p className="text-xs sm:text-sm text-gray-400" data-id="element-532">
              <strong className="font-semibold text-white" data-id="element-533">4.8 stars</strong>
              <span className="mx-1.5 text-gray-600" data-id="element-534">|</span>
              <strong className="font-semibold text-white" data-id="element-535">10K+</strong> reviews
              <span className="mx-1.5 text-gray-600" data-id="element-536">|</span>
              <strong className="font-semibold text-white" data-id="element-537">10K+</strong> members
            </p>
          </div>

          <p className="mt-3 sm:mt-4 text-xs text-gray-500 font-light" data-id="element-538">
            Free Shipping on Orders Over $50
          </p>
        </motion.div>
      </div>
    </section>;
}